import { trigger, transition, style, animate } from '@angular/animations'

export const expandAnimation = trigger('expandAnimation', [
  transition(':leave', [style({ height: '*' }), animate('.2s ease-out', style({ height: '0', overflow: 'hidden' }))]),
  transition(':enter', [style({ height: '0', overflow: 'hidden' }), animate('.2s ease-out', style({ height: '*' }))])
])
